import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import '../common.css';
import './Note.css';
export function useToast(defaultProps = {}) {
    const [toast, setToast] = useState({ invisible: true, show: true, type: 'info', children: 'No text set', ...defaultProps });
    const [timeoutId, setTimeoutId] = useState();
    return [(props, timeoutMs = 1000) => {
            const p = typeof props === 'string' ? { children: props } : props;
            timeoutId && clearTimeout(timeoutId);
            setToast({ ...toast, ...p, show: true, invisible: false });
            setTimeoutId(setTimeout(() => {
                setToast({ ...toast, invisible: true });
                setTimeoutId(undefined);
            }, timeoutMs));
        },
        toast];
}
const Note = ({ type = 'error', show = true, invisible = false, className, children }) => {
    return _jsx(_Fragment, { children: _jsx("div", { className: `note ${type} ${show ? 'show' : 'noshow'} ${invisible ? 'invisible' : ''} ${className !== null && className !== void 0 ? className : ''}`, children: children }) });
};
export default Note;
